import { getAppConfig } from '@services/config';
import { apiHttpService } from '@services/http';
import { HttpService } from '@services/http/http';

import { UserType } from '@app-types/user';

import { Interest } from '@models/interest';

const appConfig = getAppConfig();

export class InterestService {
    private httpService: HttpService;

    public constructor(httpService: HttpService) {
        this.httpService = httpService;
    }

    public async create({ person, choices, address }: Interest, user?: UserType): Promise<void> {
        const headers: Record<string, string> = {};

        return this.httpService.post(
            `${appConfig.b2r.url}/prospects/declaration-interet`,
            {
                technologie: choices.technology,
                civilite: person.title,
                nom: person.lastName,
                prenom: person.firstName,
                telephone: person.phone,
                email: person.email,
                estMigration: choices.isRelocation ? 1 : 0,
                autoriseAppel: choices.authorizeCall ? 1 : 0,
                autoriseSmsEtEmail: choices.authorizeSmsOrEmail ? 1 : 0,
                adresse: {
                    numeroVoie: address.streetNumber,
                    extension: address.extension,
                    voie: address.street,
                    codePostal: address.postalCode,
                    commune: address.city,
                    codeInsee: address.inseeCode,
                    codeVoie: address.streetCode,
                },
            },
            {
                headers,
                user,
                ttl: 0,
            },
        );
    }
}

export const interestService = new InterestService(apiHttpService);
